import * as api from '../api'

export const getExpenses = () => async (dispatch) => {
  try {
    const { data } = await api.fetchExpenses()
    dispatch({ type: 'FETCH_EXPENSES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
